import { render, staticRenderFns } from "./AgendarAtencionEnCasa.vue?vue&type=template&id=5608ec13&scoped=true&"
import script from "./AgendarAtencionEnCasa.vue?vue&type=script&lang=js&"
export * from "./AgendarAtencionEnCasa.vue?vue&type=script&lang=js&"
import style0 from "./AgendarAtencionEnCasa.vue?vue&type=style&index=0&id=5608ec13&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5608ec13",
  null
  
)

export default component.exports